module.exports = __webpack_public_path__ + "static/media/shapes_18.402b492c.svg";